<template>
  <div class="main-page">
    <VueHeader></VueHeader>
    <img class="bg-img" src="@/assets/images/bg.png" alt="background image" />
    <h1>Маркет<br>Новостроек</h1>
    <div class="wrapper" :class="{ filtersOpen: isFiltersOpen }">
      <form class="main-search" ref="searchForm">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.2402 14.7245L18.7402 18.2245" stroke="#666666" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            d="M4.74023 10.2245C4.74023 13.5382 7.42652 16.2245 10.7402 16.2245C12.3999 16.2245 13.9023 15.5506 14.9885 14.4615C16.071 13.3762 16.7402 11.8785 16.7402 10.2245C16.7402 6.91078 14.0539 4.22449 10.7402 4.22449C7.42652 4.22449 4.74023 6.91078 4.74023 10.2245Z"
            stroke="#666666" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <search-input @value-input="searchInputed"></search-input>
        <v-select :select-name="'typeOfApartment'" :selectId="0" :selectName="typeOptions.name"
          :options="typeOptions.value" :selected="typeOptions.translation" :selectSet="typeOptions.isSet"
          @select="selectHandler" ref="typeFilter"></v-select>
        <price-filter :selectId="1" :filterList="filterValues" @select="selectHandler" ref="priceFilter"
          id="filter1"></price-filter>
        <v-select :select-name="'typeOfDate'" :selectId="2" :selectName="dateOption.name" :options="dateOption.value"
          :selected="dateOption.translation" :selectSet="false" @select="selectHandler" ref="dateFilter"></v-select>
        <all-filters @select="selectHandler" @filterResets="resetForm" @search="searchResults"
          @filtersOpen="filtersAction" :isResetShow="isResetShow" :LocationFilters="locationList"
          :HouseFilters="houseList" :ApartmentFilters="apartmentList" ref="allFitlers"></all-filters>
        <div class="added-filters-list">
          <filter-item v-for="filter in filterValues" :info="filter" @clearFilter="deleteFilter"></filter-item>
        </div>
        <button @click="searchResults" type="button" class="show-results">Найти</button>
      </form>
      <section v-show="isResultShow" class="search-result-block">
        <h2>{{ complex_count }} комплексов</h2>
        <complex-item class="search-result-block__item" v-for="complex, number in complexList" :key="number"
          :complexData="complex"></complex-item>
        <button @click="showMore" v-if="isMore" class="more-btn">Показать ещё</button>
      </section>
    </div>
  </div>
</template>

<script>
import VueHeader from "@/components/VueHeader.vue";
import VSelect from "@/components/v-select.vue";
import VInputselect from "@/components/v-inputselect.vue";
import AllFilters from "@/components/AllFilters.vue";
import ComplexItem from "@/components/ComplexItem.vue";
import PriceFilter from "@/components/PriceFilter.vue";
import SearchInput from "@/components/SearchInput.vue";
import FilterItem from "@/components/FilterItem.vue";
import { getFilters, searchComplexes } from "@/assets/scripts/api";

export default {
  name: "HomeView",
  components: {
    VueHeader,
    VSelect,
    AllFilters,
    VInputselect,
    ComplexItem,
    PriceFilter,
    SearchInput,
    FilterItem
  },
  data() {
    return {
      isResultShow: false,
      apartment_count: 0,
      complex_count: 0,
      searchValue: '',
      typeOptions: {
      },
      dateOption: {
      },
      filterValues: [],
      complexList: [],
      isResetShow: false,
      isFiltersOpen: false,
      paginationNumber: 0,
      isMore: true,
      locationList: [],
      houseList: [],
      apartmentList: []
    }
  },
  watch: {
    filterValues: {
      handler() {
        if (this.filterValues.length > 0) {
          this.isResetShow = true
        }
        else {
          this.isResetShow = false
        }
      },
      deep: true
    },
  },

  created() {
    document.title = 'Маркет Новостроек';
    this.getFiltersData();
  },

  methods: {
    searchInputed(value) {
      this.searchValue = value
    },
    resetForm() {
      this.searchValue = ''
      this.$refs.searchForm.reset();
      this.filterValues = []
      this.$refs.priceFilter.clearInputs()
    },

    deleteFilter(name) {
      this.filterValues = this.filterValues.filter((item) => {
        return item.name !== name;
      })
      this.$refs.typeFilter.checkList(this.filterValues);
      this.$refs.priceFilter.checkList();
      this.$refs.dateFilter.checkList(this.filterValues);
      this.$refs.allFitlers.checkForm()
    },

    getFiltersData() {
      getFilters().then(answer => {
        let filtersDataFromServer = answer;
        this.dateOption = filtersDataFromServer.find(e => e.group === null).filter_list.find(e => e.name === "deadline")
        this.typeOptions = filtersDataFromServer.find(e => e.group === null).filter_list.find(e => e.name === "type_apartments")
        this.locationList = filtersDataFromServer.find(e => e.group === 'Расположение').filter_list;
        this.houseList = filtersDataFromServer.find(e => e.group === 'Дом').filter_list;
        this.apartmentList = filtersDataFromServer.find(e => e.group === 'Квартира').filter_list;
      })
    },

    async searchResults() {
      let filterArray = [];
      this.filterValues.forEach(value => {
        let item = {
          name: value.name,
          value: value.value
        }
        filterArray.push(item)
      })
      let formData = {
        'search_text': this.searchValue,
        'filter': filterArray,
        'pagination': this.paginationNumber
      };
      let complexesFromServer = await searchComplexes(formData);
      this.complexList = complexesFromServer.content;
      this.complex_count = complexesFromServer.count
      if (this.complexList.length < 10) {
        this.isMore = false
      }
      else {
        this.isMore = true
      }
      this.isResultShow = true
    },


    async showMore() {
      this.paginationNumber += 10

      let formData = {
        'search_text': this.searchValue,
        'filter': this.filterValues,
        'pagination': this.paginationNumber
      };
      let complexesFromServer = await searchComplexes(formData);
      let newList = complexesFromServer.content;
      if (newList.length < 10) {
        this.isMore = false
      }
      else {
        this.isMore = true
      }
      let wholeList = [...this.complexList, ...newList]
      this.complexList = wholeList;
    },

    selectHandler(option) {
      let index = this.filterValues.findIndex(e => e.name === option.name);

      if (index !== -1) {
        this.filterValues[index].value = option.value;

        if (option.value.length == 0) {
          this.filterValues = this.filterValues.filter((item) => {
            return item.name !== option.name;
          })
        }
      }
      else {
        this.filterValues.push(option)
      }
    },

    filtersAction(value) {
      this.isFiltersOpen = value
    }
  }
};
</script>

<style lang="scss">
.main-page {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;

  position: relative;

  .wrapper {
    position: relative;
    z-index: 2;

    &.filtersOpen {
      margin-bottom: 800px;
    }
  }

  .more-btn {
    display: block;

    padding: 15px 75px;
    background-color: $button-color;
    color: white;
    border-radius: 10px;

    margin: 40px auto 0;

    @extend %BODY1;
  }

  h1 {
    position: relative;
    z-index: 2;

    @extend %H1;
    font-size: 80px;
    line-height: 110%;
    font-weight: 800;

    margin-top: 100px;
    text-align: center;
  }

  .bg-img {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    object-fit: cover;
    object-position: top;
    z-index: -1;
  }

  .main-search {
    display: block;

    padding: 15px 20px;
    background-color: white;

    margin-top: 80px;

    display: flex;
    align-items: center;

    position: relative;

    border-radius: 15px;

    >svg {
      flex-shrink: 0;
      margin-bottom: 2px;
    }

    .added-filters-list {
      position: absolute;
      display: flex;
      flex-wrap: wrap;
      width: 70%;

      top: 80px;
      left: 0;

      gap: 10px;
      row-gap: 15px;
    }

    &__input {
      padding: 10px 5px;
      @extend %H3;
      color: $font-color;
      width: 100%;
      margin-left: 10px;

      &::placeholder {
        color: $second-font-color;
        font-size: 14px;
      }
    }

    &__label {
      position: absolute;
      left: 20px;
      top: -35px;
      @extend %BODY1;
    }

    .filter {
      background-color: transparent;
      white-space: nowrap;
      margin-left: 20px;
    }

    .show-results {
      position: absolute;
      right: 0;
      top: 80px;

      padding: 15px 75px;
      background-color: $button-color;
      color: white;
      border-radius: 15px;

      @extend %BODY1;
    }
  }

  .search-result-block {
    margin-top: 120px;
    margin-bottom: 100px;

    h2 {
      margin-bottom: 30px;

      font-size: 22px;
    }

    &__item {
      display: block;
      width: 100%;

      margin-top: 20px;
    }


    .wrapper {
      position: relative;
      z-index: 1;
    }
  }
}

@media screen and (max-width: 1200px) {
  .main-page {
    .search-input-main {
      margin-left: 30px;
    }

    .main-search {
      flex-wrap: wrap;

      >svg {
        position: absolute;
        left: 20px;
        top: 28px;
      }

      &__input {
        margin-left: 30px;
        margin-bottom: 20px;
      }

      .added-filters-list {
        top: 120px;
      }

      >.v-select {
        width: 25%;
      }

      .show-results {
        top: 120px;
      }
    }
  }
}

@media screen and (max-width: 800px) {
  .main-page {
    h1 {
      font-size: 40px;
      margin-top: 50px;
    }

    .search-result-block {
      margin-top: 180px;
    }

    .wrapper {
      &.filtersOpen {
        >form {
          margin-bottom: 1400px;
        }
      }
    }

    .search-input-main {
      margin-left: 25px;
    }

    .main-search {
      padding: 5px 10px 15px;
      margin-top: 60px;

      .reset-button {
        width: 100%;
      }

      &__label {
        left: 11px;
      }

      &__input {
        margin-left: 20px;
        margin-bottom: 15px;

        &::placeholder {
          color: $second-font-color;
          font-size: 16px;
        }
      }

      .added-filters-list {
        top: 275px;
      }

      >svg {
        top: 16px;
        left: 10px;
      }

      >.v-select {
        width: 100%;

        .v-select__container {
          width: 100%;
          padding: 8px 10px 8px 3px;
        }

        .v-select__options {
          min-width: 100%;
          width: 100%;

          top: 30px;
        }
      }

      .filter {
        margin-left: 3px;
        margin-top: 10px;
      }

      .show-results {
        right: 0;
        width: 100%;
        top: 215px;
        display: block;
        text-align: center;
      }
    }
  }

  .more-btn {
    display: block;

    width: 100%;
    text-align: center;

    margin: 30px auto 0;
  }
}
</style>
